import { createStore } from 'vuex'

export default createStore({
    state: {
        isLoginPage: false //是否是登录页
    },
    getters: {
        isLoginPage: state => state.isLoginPage
    },
    mutations: {
        setLogin(state, value) {
            state.isLoginPage = value
        }
    },
    actions: {
        updateLogin({ commit }, value) {
            commit('setLogin', value);
        }
    },
    modules: {
    }
})
